import { forwardRef } from 'react';

import { icon_basket } from '@gn-audio/icons';

import { useFallbackTranslation } from '../../utils/hooks';
import { EcomOnly } from '../EcomOnly/EcomOnly';
import { JabraIcon } from '../JabraIcon/JabraIcon';
import { useHeaderNavigation } from '../MegaMenu';
import { useBasket } from './BasketContext/useBasket';
import { BasketQuantityBadge } from './common/BasketQuantityBadge';

export const Icon = () => {
  const { toggleBasket } = useBasket();
  const { closeMenu } = useHeaderNavigation();
  const { t } = useFallbackTranslation();

  const onBasketClick = () => {
    closeMenu();
    toggleBasket();
  };

  return (
    <button
      className="btn-top-menu"
      title={t('cart.YourCart')}
      aria-label={t('cart.YourCart')}
      onClick={onBasketClick}
    >
      <JabraIcon Icon={icon_basket} />
      <BasketQuantityBadge />
    </button>
  );
};

export const BasketButton = forwardRef(() => {
  return (
    <EcomOnly>
      <Icon></Icon>
    </EcomOnly>
  );
});

BasketButton.displayName = 'BasketButton';
